<template>
  <div class="px-2">
    <v-toolbar dense color="transparent" class="my-1 elevation-0">
      <h2 class="ml-n3">Gestão do Comprador</h2>

      <v-spacer />

      <SysCompradorAutocomplete
        v-model="filtros.comprador"
        label="Comprador"
        hide-details
        outlined
        dense
        multiple
        :qtde_visivel_selecionados="1"
        clearable
        class="ml-2"
        append-icon="mdi-chevron-down"
        @blur="buscarDados()"
      />

      <SysFornecedorAutocomplete
        v-model="filtros.fornecedor"
        label="Fornecedor"
        hide-details
        outlined
        dense
        multiple
        clearable
        :qtde_visivel_selecionados="1"
        class="ml-2"
        append-icon="mdi-chevron-down"
        @blur="buscarDados()"
      />

      <v-btn right class="ml-2 mr-n3" color="primary" @click="exportarParaExcel">
        <v-icon left>$Excel</v-icon>
        exportar
      </v-btn>

    </v-toolbar>

    <div>
      <sys-data-table
        :headers="headers"
        :items="desserts"
        :height="alturaDaJanela - 126"
        :item-height="40"
        hide-default-footer
        class="elevation-1"
      >
        <template #header>
          <tr>
            <th colspan="1" class="border-right-grey"></th>
            <th class="text-center border-right-grey" colspan="3">Compras em (R$)</th>
            <th class="text-center border-right-grey" colspan="6">Análise estoque</th>
            <th class="text-center border-right-grey" colspan="3">Ruptura</th>
            <th class="text-center border-right-grey" colspan="2">Saving</th>
            <th class="text-center border-right-grey" colspan="5">Comportamento da compra</th>
          </tr>
        </template>

        <template #item.ano="{ item }">
          <span v-text="`${(Helpers.nomeMeses[item.mes - 1] || ' - ').substring(0, 3)}/${item.ano}`" />
        </template>

        <template #item.pedidos_em_valor="{ value }">
          {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.entregue_em_valor="{ value }">
          {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.pendente_em_valor="{ value }">
          {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.sku_com_estoque="{ value }">
          {{ Helpers.formatarValor(value) }}
        </template>

        <template #item.valor_estoque="{ value }">
          {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.sku_excesso="{ value }">
          {{ Helpers.formatarValor(value) }}
        </template>

        <template #item.valor_excesso="{ item }">
          {{ Helpers.formatarValorComCasas(item.valor_excesso, 0) }}
        </template>

        <template #item.porcentagem_excesso="{ value }">
          {{ Helpers.formatarValorComCasas(value, 1) }}%
        </template>

        <template #item.faturamento="{ value }">
          {{ Helpers.formatarValorComCasas(value, 1) }}
        </template>

        <template #item.sku_ruptura="{ value }">
          {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.valor_ruptura="{ value }">
          {{ Helpers.formatarValorComCasas(value, 0) }}
        </template>

        <template #item.porcentagem_ruptura="{ value }">
          {{ Helpers.formatarValorComCasas(value, 1) }}%
        </template>

        <template #item.valor_saving="{ value }">
          <span :class="{'text-red': Number(value) > 0, 'text-green': Number(value) < 0}">
            {{ Helpers.formatarValorComCasas(Math.abs(value), 0) }}
          </span>
        </template>

        <template #item.porcentagem_saving="{ value }">
          <span :class="{'text-red': Number(value) > 0, 'text-green': Number(value) < 0}">
            {{ Helpers.formatarValorComCasas(Math.abs(value), 1) }}%
          </span>
        </template>

        <template #item.porcentagem_exposto="{ value }">
          {{ Helpers.formatarValorComCasas(value, 1) }}%
        </template>

        <template #item.porcentagem_ponto_pedido="{ value }">
          {{ Helpers.formatarValorComCasas(value, 1) }}%
        </template>

        <template #item.porcentagem_prematuridade="{ value }">
          {{ Helpers.formatarValorComCasas(value, 1) }}%
        </template>

        <template #item.porcentagem_sem_comportamento="{ value }">
          {{ Helpers.formatarValorComCasas(value, 1) }}%
        </template>

      </sys-data-table>
    </div>
  </div>
</template>

<script>
import Responsividade from '../../../helpers/ResponsiveHeight';
import SysCompradorAutocomplete from '../../utils/crud/SysCompradorAutocomplete';
import SysFornecedorAutocomplete from '../../utils/crud/SysFornecedorAutocomplete';
import Headers from './Headers';

import $axios from "@/api/api";
import { buscarDadosGestaoComprador } from '../../../api/indicadores';
import { mapGetters } from 'vuex';

export default {
  mixins: [Responsividade],
  components: {
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete
  },
  data() {
    return {
      desserts: [],
      headers: Headers,
      loading: {
        comprador: true,
        fornecedor: true,
      },
      filtros: {
        comprador: [],
        fornecedor: [],
      },
    }
  },
  created() {
    this.buscarDados();
  },
  computed: {
    ...mapGetters({
      grupo_compra: "usuario/getGrupoCompras"
    })
  },
  watch: {
    grupo_compra() {
      this.buscarDados();
    },
    "filtros.comprador"() {
      this.buscarDados();
    },
    "filtros.fornecedor"() {
      this.buscarDados();
    }
  },
  methods: {
    buscarDados() {
      const params = {
        ...this.filtros,
        id_grupo: this.grupo_compra
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarDadosGestaoComprador(params)
          .then((valor) => this.desserts = valor)
          .catch(() => this.Helpers.logout())
      );
    },
    exportarParaExcel() {
      const url = '/relatorios/indicadores/gestao-do-comprador/exportacao-excel';
      const params = `?id_grupo=${this.grupo_compra}&comprador=${this.filtros.comprador}&fornecedor=${this.filtros.fornecedor}`;

      window.open($axios.defaults.baseURL + url + params, "_blank");
    }
  }
}
</script>

<style>
.border-right-grey {
  border-right: 1px solid #d3d3d3;
}
</style>
